import script from "./DashboardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHeader.vue?vue&type=style&index=0&id=31dd6b57&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31dd6b57"]])

export default __exports__